import type { RateCard } from '@/models/rateCard';

const norm = (value?: string) => value?.trim().toLowerCase() ?? '';

export type RateCardProductLookup = {
  channel?: string;
  product?: string;
};

/**
 * Products are unique per rate-card row. Find that row by channel + product
 * (no KPI, no aggregated sellRates). Prefer a published row if a draft duplicate exists.
 */
export function findRateCardByProduct(
  rateCards: RateCard[],
  { channel, product }: RateCardProductLookup
): RateCard | undefined {
  if (!channel?.trim() || !product?.trim()) return undefined;

  const channelKey = norm(channel);
  const productKey = norm(product);
  const matches = rateCards.filter(
    (rc) => norm(rc.channel) === channelKey && norm(rc.product) === productKey
  );
  if (!matches.length) return undefined;

  const published = matches.filter((rc) => !rc.isDraft);
  return (published.length ? published : matches)[0];
}

export function resolveRateCardProductSellRate(
  rateCards: RateCard[],
  lookup: RateCardProductLookup
): number | undefined {
  const row = findRateCardByProduct(rateCards, lookup);
  if (row?.sellRate == null || !Number.isFinite(Number(row.sellRate))) return undefined;
  return Number(row.sellRate);
}
